import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

// Detect if inside Instagram's in-app browser
// const isInstagram = navigator.userAgent.includes("Instagram");

// // Optional: Warn Instagram users (you can remove or replace with modal)
// if (isInstagram) {
//   alert("Instagram's in-app browser may not fully support this app. Please open in Chrome or Safari for best experience.");
// }

// Create Query Client
const queryClient = new QueryClient();

// Render App Immediately
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster />
    </QueryClientProvider>
  </React.StrictMode>
);

// Measure Performance
reportWebVitals();
